import styled from 'styled-components'; 
export const Container = styled.div`
display: flex;
flex-direction: row;
background-color: var(--color-whitesmoke-300);
width: 100%;
height: 100%; 
text-align: left;
font-size: var(--font-size-xs);
color: var(--color-dimgray);
font-family: var(--font-product-sans); 
margin-top: 26px;
margin-left: 30px;
margin-right: 30px;
  
`;


